var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.platformData.name}},[_c('Avatar',{attrs:{"img-url":_vm.logo,"size":_vm.imgSize,"type":"platform"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }